import React from "react"

import HeroAbout from "../HeroAbout"
import { Done } from "@styled-icons/material-rounded/Done"
import { Twitter } from "@styled-icons/boxicons-logos/Twitter"
import { Linkedin } from "@styled-icons/fa-brands/Linkedin"
import { Github } from "@styled-icons/boxicons-logos/Github"

import {
  Wrapper,
  Content,
  Infos,
  Title,
  Section,
  Text,
  List,
  Skill,
  Name,
  Contacts,
  Contact,
  Social,
  SocialItem,
  SocialItemLink,
} from "./styled"

const About = () => (
  <Wrapper>
    <HeroAbout />
    <Content>
      <Infos>
        <Section>
          <Title className="who">Quem somos</Title>
          <Text>
            Meu nome é Christopher Hauschild Schott, tenho 19 anos, nasci em
            Santa Maria/RS e estou cursando o Técnico em Informática pelo IFSul
            Venâncio Aires. Meu nome é Christy Hauschild Schott, também tenho 19
            anos, também nasci em Santa Maria/RS e também estou cursando o
            Técnico em Informática pelo IFSul Venâncio Aires.
          </Text>
          <Text>
            E as semelhanças não param por aí! Nós dois somos apaixonados por
            tecnologia e também por adquirir e compartilhar conhecimento. Por
            isso estamos tão envolvidos com a área de desenvolvimento, que além
            de oferecer a facilidade de se aprender algo novo a cada dia, nos
            possibilita ajudar um grande número de pessoas por vez.
          </Text>
          <Text>
            Com isso em mente, decidimos criar o Coday, um blog com um número
            crescente de artigos pensados e escritos com muita dedicação para vocês!
            Esperamos te ver aqui mais vezes, pois o Coday foi pensado com muito
            carinho, para que você possa ficar ainda mais próximo desse mundão
            da tecnologia e do nosso mundo particular também!
          </Text>
        </Section>
        <Section className="skills">
          <Title>Habilidades</Title>
          <List>
            <Skill>
              <Done /> HTML
            </Skill>
            <Skill>
              <Done /> CSS (Sass, Bootstrap)
            </Skill>
            <Skill>
              <Done /> JavaScript
            </Skill>
            <Skill>
              <Done /> React / Redux
            </Skill>
            <Skill>
              <Done /> NodeJS
            </Skill>
            <Skill>
              <Done /> TypeScript
            </Skill>
            <Skill>
              <Done /> React Native
            </Skill>
            <Skill>
              <Done /> Git
            </Skill>
            <Skill>
              <Done /> E soft skills de sobra!
            </Skill>
          </List>
        </Section>
        <Section>
          <Title>Contato</Title>
          <Text className="contact">
            Você pode entrar em contato conosco através de qualquer uma das
            nossas redes sociais.
          </Text>

          <Contacts>
            <Contact>
              <Name>Christy</Name>
              <Social>
                <SocialItem>
                  <SocialItemLink
                    target="_blank"
                    href="https://twitter.com/hauescudo"
                  >
                    <Twitter />
                  </SocialItemLink>
                </SocialItem>
                <SocialItem>
                  <SocialItemLink
                    target="_blank"
                    href="https://www.linkedin.com/in/christy-hauschild/"
                  >
                    <Linkedin />
                  </SocialItemLink>
                </SocialItem>
                <SocialItem>
                  <SocialItemLink
                    target="_blank"
                    href="https://github.com/christyschott"
                  >
                    <Github />
                  </SocialItemLink>
                </SocialItem>
              </Social>
            </Contact>
            <Contact>
              <Name>Christopher</Name>
              <Social>
                <SocialItem>
                  <SocialItemLink
                    replace={false}
                    target="blank"
                    href="https://twitter.com/GuizinhoHaus"
                  >
                    <Twitter />
                  </SocialItemLink>
                </SocialItem>
                <SocialItem>
                  <SocialItemLink
                    target="blank"
                    href="https://www.linkedin.com/in/christopher-hauschild-a091871a4/"
                  >
                    <Linkedin />
                  </SocialItemLink>
                </SocialItem>
                <SocialItem>
                  <SocialItemLink
                    target="blank"
                    href="https://github.com/ChristopherHauschild"
                  >
                    <Github />
                  </SocialItemLink>
                </SocialItem>
              </Social>
            </Contact>
          </Contacts>
        </Section>
      </Infos>
    </Content>
  </Wrapper>
)

export default About
